<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div :class="youtube" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      youtube: process.env.VUE_APP_YOUTUBE_ELF,
    };
  },
};
</script>
